import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const GovernorateFormModal = ({ isOpen, onClose, onSave, governorate, mode, language }) => {
  const [formData, setFormData] = useState({
    name: ''
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (governorate) {
      setFormData({
        name: governorate?.name || ''
      });
    } else {
      setFormData({ name: '' });
    }
    setErrors({});
  }, [governorate, isOpen]);

  const labels = {
    addTitle: { en: 'Add New Governorate', ar: 'إضافة محافظة جديدة' },
    editTitle: { en: 'Edit Governorate', ar: 'تعديل المحافظة' },
    name: { en: 'Governorate Name', ar: 'اسم المحافظة' },
    cancel: { en: 'Cancel', ar: 'إلغاء' },
    save: { en: 'Save', ar: 'حفظ' },
    required: { en: 'This field is required', ar: 'هذا الحقل مطلوب' }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.name?.trim()) {
      newErrors.name = labels?.required?.[language];
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (validateForm()) {
      onSave(formData);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors?.[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-elevation-4 border border-border w-full max-w-md">
        <div className="border-b border-border px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-foreground">
            {mode === 'add' ? labels?.addTitle?.[language] : labels?.editTitle?.[language]}
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-smooth"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <Input
            label={labels?.name?.[language]}
            value={formData?.name}
            onChange={(e) => handleChange('name', e?.target?.value)}
            error={errors?.name}
            required
          />

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              fullWidth
              onClick={onClose}
            >
              {labels?.cancel?.[language]}
            </Button>
            <Button
              type="submit"
              variant="default"
              fullWidth
            >
              {labels?.save?.[language]}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GovernorateFormModal;